export const errorCodeLang = {
  en: {
    500: 'Server Error, please try again later',
    504: 'Request Timeout, please try again later',
    '0x0': 'Success',
    '0x81001002': 'System Error',
    '0x81001003': 'No Handler Found',
    '0x81001004': 'Acquire Lock Error',
    '0x81002002': 'Validation Error',
    '0x81002003': 'Validator Not Found',
    '0x81002004': 'J2N Syntax: The graph cannot be processed due to missing required fields.graph',
    '0x81002005': "J2N Syntax: Cannot set both 'Object ID' and 'Source' for the same process.Please specify only one.",
    '0x81002006': "J2N Syntax: 'Object ID' and 'Tangible ID' must both be configured",
    '0x81002007': 'J2N Syntax: Cannot link two processes together',
    '0x81002008': 'J2N Syntax: Invalid field value',
    '0x81003002': 'Graph Initialization Error',
    '0x81004002': 'Evaluation Error',
    '0x81004003': 'Resource reservation request succeeded, but reservation failed.Please confirm that the agent boxes have sufficient resources remaining.',
    '0x81004004': 'Resource reservation request failed',
    '0x81004005': 'API Request Fail: Failed to retrieve box resource from Resource Service.',
    '0x81004006': 'API Request Fail: Failed to retrieve pool resource from Resource Service.',
    '0x81004007': 'API Request Fail: Failed to retrieve cloud resource from Resource Service.',
    '0x81004008': 'Box Not Found: Box with the specified Box ID was not found',
    '0x81004009': 'Box Not Found: Box with the specified Pool ID was not found.',
    '0x8100400A': 'Allocate resource error',
    '0x8100400B': 'Box found, but it is currently unavailable.',
    '0x81005002': 'Expand Error',
    '0x81005003': 'Expand Error: RSHM Edge',
    '0x81005004': 'Expand Error: ISSP',
    '0x81006002': 'Creation Error',
    '0x81006003': 'Creation Error: Box ID Not Found during creation',
    '0x81006004': 'Creation Error: Process Creation Failure',
    '0x81006005': 'Creation Error: Process Creation Error',
    '0x81007002': 'Orchestration Error',
    '0x81007003': 'Orchestration Error: No ID Not Found during Orchestration',
    '0x81007004': 'Orchestration Error: Process Orchestration Response Failure',
    '0x81007005': 'Orchestration Error: Process Orchestration Failure',
    '0x81008002': 'Release Error',
    '0x81009002': 'Restoration Error',
    '0x8100A002': 'Graph Error',
    '0x8100A003': 'Create graph error',
    '0x8100A004': 'Create graph process error',
    '0x8100A005': 'Create graph edge error',
    '0x8100A006': 'Graph worker error',
    '0x8100A007': 'Graph worker dispatch error',
    '0x8100A008': 'Graph worker getting pending graph error',
    '0x8100A009': 'Graph worker query graph error',
    '0x8100A00A': 'Graph worker opeation error',
    '0x8100A00B': 'Graph process duplication error',
    '0x8100A00C': 'No graph process found',
    '0x8100B002': 'Graph process generic error',
    '0x8100B003': 'No graph process type found',
    '0x8100B004': 'No process found',
    '0x8100B005': 'Bind process response error',
    '0x8100B006': 'Bind process error',
    '0x8100B007': 'Unbind process response error',
    '0x8100B008': 'Unbind process error',
    '0x8100B009': 'Release resource response error',
    '0x8100B00A': 'No evaluated box id found',
    '0x8100B00B': 'No status item found	graph',
    '0x8100B00C': 'No process info found',
    '0x8100B00D': 'No process id found',
    '0x8100B00E': 'No tangible id found	graph',
    '0x8100B00F': 'Get object tangible error',
    '0x8100B010': 'Delete object tangible error',
    '0x8100B011': 'Create object tangible error',
    '0x8100B012': 'Update object tangible error',
    '0x8100B013': 'Get tangible error',
    '0x8100B014': 'Delete tangible error',
    '0x8100B015': 'Create tangible error',
    '0x8100B016': 'Update tangible error',
    '0x8100B017': 'Add tangible reference error',
    81301040: 'Current switcher is starting, please wait',
    81301041: 'All Output(s) are occupied',
    81301042: "Not support source switching when the encoding profile is set to 'Follow Input'",
    81301043: 'The previous decoder is still switching',
    81301045: 'No YUV Color Correction',
    81301047: "Not support Follow Input when 'Color Correction' is enabled in the source settings",
    81301014: 'Not support editing default encoding profile',
    81301027: 'Please do not repeat the operation',
    81301018: 'No active output',
    81301017: 'Not support deleting output account in use',
    81301015: 'Not support deleting default encoding profile',
    81301033: "Object doesn't exist",
    81204008: 'Please confirm object environment, current object is not exist',
    81204009: 'SDI is not exist',
    81204011: 'Not support Follow Input for current source',
    8004040: 'There are multiple edits in progress. Please try again later.',
    813014040: 'There are multiple edits in progress. Please try again later.',
    81305400: 'No active output need to streaming',
    81301050: 'Source is not exist',
    '0xFFFFFFFF': 'A system error occurred. Please try again or contact support.',
    '0x80000000': 'The operation is invalid or not applicable.',
    '0x80000001': 'Input parameters are incorrect or missing. Please check and try again.',
    '0x80000002': 'Missing request ID. Please include a valid request ID.',
    '0x80001000': 'The specified process does not exist or was already deleted.',
    '0x80001100': 'The specified Origin ID does not exist.',
    '0x80001200': 'The selected Pack device is offline. Please power it on and try again.',
    // '0x80001201': 'The Pack is already streaming to another receiver.',
    '0x80001202': 'The Pack is in an invalid state for this operation.',
    '0x80002000': 'The specified box does not exist or has been deleted.',
    '0x80002001': 'The box is offline. Please bring it online to proceed.',
    '0x80002002': 'The box is not activated. Activation is required for this operation.',
    '0x80002100': 'The selected box pool does not exist or was removed.',
    '0x80003000': 'Not enough resources in the box pool to run the task.',
    // '0x80004000': 'Not enough ports are available on the selected box. Please configure additional port mappings on the [Port Mapping Page]',
    '0x80005000': 'The selected encoding profile does not exist. Please choose a valid profile.',
    '0x81401100': 'Docker Image not found'
  },
  zh: {
    500: '服务异常，请稍后重试',
    504: '请求超时，请稍后重试',
    '0x81001002': '系统错误',
    '0x81001003': '没有找到处理程序',
    '0x81001004': '请求锁错误',
    '0x81002002': '验证graph错误',
    '0x81002003': '找不到验证器',
    '0x81002004': '缺失某些字段',
    '0x81002005': 'objectid和source不能同时设置',
    '0x81002006': 'objectid和tangible必须同时设置',
    '0x81002007': '不能连接两个process',
    '0x81002008': 'J2N Syntax',
    '0x81003002': '初始化graph错误',
    '0x81004002': '评估graph错误',
    '0x81004003': '保留resource错误',
    '0x81004004': '保留resource请求的回复错误',
    '0x81004005': '通过box id获取box请求的回复错误',
    '0x81004006': '通过pool id获取box请求的回复错误',
    '0x81004007': '获取TVU SaaS资源请求的回复错误',
    '0x81004008': '通过box id没有获取到任何box',
    '0x81004009': '通过pool id没有获取到任何box',
    '0x8100400A': '分配资源到box失败',
    '0x8100400B': '没有评估到任何box',
    '0x81005002': '展开graph edge错误',
    '0x81005003': '展开remote shm类型的edge错误',
    '0x81005004': '展开bridge(issp)类型的edge错误',
    '0x81006002': '创建graph错误',
    '0x81006003': '创建graph时没有找到box id',
    '0x81006004': '创建process请求的回复错误',
    '0x81006005': '创建process错误',
    '0x81007002': '调度graph错误',
    '0x81007003': '调度graph时没有找到box id',
    '0x81007004': '调度process请求的回复错误',
    '0x81007005': '调度process错误',
    '0x81008002': '释放graph错误',
    '0x81009002': '恢复graph错误',
    '0x8100A002': 'graph错误',
    '0x8100A003': '创建graph对象错误',
    '0x8100A004': '创建graph process对象错误',
    '0x8100A005': '创建graph edge对象错误',
    '0x8100A006': 'graph worker执行错误',
    '0x8100A007': 'graph worker执行dispatch错误',
    '0x8100A008': 'graph worker获取挂起的graph时错误',
    '0x8100A009': 'graph worker查询到graph错误',
    '0x8100A00A': 'graph worker执行operation时错误',
    '0x8100A00B': 'graph process重复错误',
    '0x8100A00C': 'graph中没有查询到graph process	',
    '0x8100B002': 'graph process错误',
    '0x8100B003': '未知的graph process类型',
    '0x8100B004': '没有查询到process',
    '0x8100B005': '绑定process请求的回复错误',
    '0x8100B006': '绑定process错误',
    '0x8100B007': '解绑process请求的回复错误',
    '0x8100B008': '解绑process错误',
    '0x8100B009': '释放资源请求的回复错误	',
    '0x8100B00A': 'graph process没有box id',
    '0x8100B00B': 'process的状态中没有该项数据',
    '0x8100B00C': 'graph process中没有process信息',
    '0x8100B00D': 'graph process中没有process id信息',
    '0x8100B00E': 'process中没有tangible id信息',
    '0x8100B00F': '获取object tangible错误',
    '0x8100B010': '删除object tangible错误',
    '0x8100B011': '创建object tangible错误',
    '0x8100B012': '更新object tangible错误',
    '0x8100B013': '获取tangible错误',
    '0x8100B014': '删除tangible错误',
    '0x8100B015': '创建tangible错误',
    '0x8100B016': '更新tangible错误',
    '0x8100B017': '增加tangible引用错误',
    81301040: '正在切换中，请稍等',
    81301041: '所有输出已占用',
    81301042: '编解码配置文件设为‘直通’时，不可切换源',
    81301043: '解码进行中，请勿重复操作',
    81301045: '无调色功能',
    81301047: '源设置开启‘调色’功能时，不可进行‘直通’配置',
    81301014: '默认编解码配置文件不可编辑',
    81301027: '请勿重复操作',
    81301018: '无推流',
    81301017: '输出账号正在使用中，不可删除',
    81301015: '默认编解码配置文件不可删除',
    81301033: '对象不存在',
    81204008: '请确认对象环境，当前对象不存在',
    81204009: 'SDI不存在',
    81204011: '当前源不可进行‘直通’编解码配置',
    8004040: '操作频繁，请稍后重试',
    813014040: '操作频繁，请稍后重试',
    81305400: '无可推流的输出',
    81301050: '源不存在',
    '0xFFFFFFFF': '系统错误',
    '0x80000000': '非法的操作，或者不适用的操作',
    '0x80000001': '接口参数验证不通过',
    '0x80000002': 'Missing request ID. Please include a valid request ID.',
    '0x80001000': 'process不存在或者已经被删除',
    '0x80001100': 'The specified Origin ID does not exist.',
    '0x80001200': 'The selected Pack device is offline. Please power it on and try again.',
    // '0x80001201': 'The Pack is already streaming to another receiver.',
    '0x80001202': 'The Pack is in an invalid state for this operation.',
    '0x80002000': 'Box 不存在，某些请求需要指定Box，但是这个Box已经删除了',
    '0x80002001': 'Box未在线，某些操作需要Box在线才可以操作，比如升级Agent',
    '0x80002002': 'Box未激活，某些操作需要Agent激活的情况下才可以操作，比如SDI 输出',
    '0x80002100': '用户指定的BoxPool不存在，或者已经被删除',
    '0x80003000': '用户指定的BoxPool资源不足以运行process',
    // '0x80004000': '所选设备的可用端口不足。请前往 [端口映射页面] 配置更多端口',
    '0x80005000': '选择的encodingprofile不存在',
    '0x81401100': '没有找到指定的Docker Image或未设置'
  }
}
export default errorCodeLang
